var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZephyrIcon = function SvgZephyrIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7929D2",
    d: "m25.55 33.432-5.096 2.776 4.334 2.824z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9454DB",
    d: "M14.546 37.111 9.11 34.485 10.37 40z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF7FE4",
    d: "m17.125 32.176 3.33 4.032-5.909.903zM9.766 28.386l-.656 6.1L5 29.192z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zephyr_icon_svg__a)",
    d: "m25.55 33.432 13.418-15.925L45 27.817z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zephyr_icon_svg__b)",
    d: "M25.55 33.432 31.283 10l7.686 7.507z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zephyr_icon_svg__c)",
    d: "M31.282 10H45l-6.032 7.507z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zephyr_icon_svg__d)",
    d: "M45 27.818V10l-6.032 7.507z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zephyr_icon_svg__a",
    x1: 31.325,
    x2: 46.753,
    y1: 25.469,
    y2: 25.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7929D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zephyr_icon_svg__b",
    x1: 32.375,
    x2: 32.16,
    y1: 7.933,
    y2: 27.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9454DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zephyr_icon_svg__c",
    x1: 40.867,
    x2: 36.165,
    y1: 16.092,
    y2: 9.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66A9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zephyr_icon_svg__d",
    x1: 41.6,
    x2: 44.673,
    y1: 10.325,
    y2: 26.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9454DB"
  })))));
};
export default SvgZephyrIcon;